(function(root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.EnigmaMtgCatalog = api;
})(typeof window !== 'undefined' ? window : null, function(root) {
  'use strict';
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[’‘]/g, "'").replace(/\s*\(v\.\d+\)\s*$/i, '')
      .replace(/\s+\/+\s+/g, ' // ').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  var keywords = {volare:'flying',follia:'madness',scartare:'discard',scarta:'discard',pescare:'draw',pesca:'draw',ritorna:'return',ritornare:'return',torna:'return',restituisci:'return',riprendi:'return',travolgere:'trample',rapidita:'haste',cautela:'vigilance',minacciare:'menace',toccoletale:'deathtouch',legamevitale:'lifelink',indistruttibile:'indestructible',lampo:'flash',raggiungere:'reach',difensore:'defender',protezione:'protection'};
  function oracleTerms(value) { return normalize(value).split(/\s+/).filter(Boolean).map(function(t) { return keywords[t] || t; }); }
  function matchesColors(cardColors, selectedColors, mode) {
    var colors=Array.isArray(cardColors)?cardColors:[],selected=Array.isArray(selectedColors)?selectedColors.filter(Boolean):[];
    if(!selected.length)return true;
    var wantsColorless=selected.indexOf('C')!==-1;
    if(wantsColorless)return mode==='exclude'?colors.length>0:colors.length===0;
    if(mode==='include')return selected.every(function(color){return colors.indexOf(color)!==-1;});
    if(mode==='exclude')return selected.every(function(color){return colors.indexOf(color)===-1;});
    return colors.length>0 && colors.every(function(color){return selected.indexOf(color)!==-1;});
  }
  function nearWord(a, b) {
    if (a.length < 5 || Math.abs(a.length-b.length)>1) return false;
    var i=0,j=0,edits=0;
    while(i<a.length && j<b.length) {
      if(a[i]===b[j]) { i++;j++;continue; }
      if(++edits>1) return false;
      if(a.length>=b.length)i++;
      if(b.length>=a.length)j++;
    }
    return edits+(a.length-i)+(b.length-j)<=1;
  }
  function scoreName(names, term, exact) {
    if (!term) return 1;
    if(names[0]===term) return 100;
    if(names.indexOf(term)!==-1) return 90;
    if(exact) return 0;
    var score=0,tokens=term.split(/\s+/);
    names.forEach(function(name) {
      if(name.indexOf(term)===0) score=Math.max(score,80);
      else if(name.indexOf(term)>0) score=Math.max(score,65);
      else {
        var words=name.split(/[^a-z0-9]+/);
        if(tokens.every(function(t) { return words.some(function(w) { return w===t || w.indexOf(t)===0; }); })) score=Math.max(score,50);
        else if(tokens.every(function(t) { return words.some(function(w) { return w===t || nearWord(t,w); }); })) score=Math.max(score,20);
      }
    });
    return score;
  }
  function create(data) {
    if(!data || data.schema!==1 || !Array.isArray(data.cards) || !Array.isArray(data.products) || !Array.isArray(data.editions)) throw new Error('Catalogo non valido');
    var names=data.cards.map(function(c) { return [c.n].concat(c.a || []).map(normalize); });
    var byName=new Map(), byHandle=new Map(), oracle=null;
    data.products.forEach(function(row,i) {
      if(!Array.isArray(row) || !/^[a-z0-9][a-z0-9-]*$/.test(row[0]) || !data.cards[row[1]] || !data.editions[row[2]]) throw new Error('Identità catalogo non valida');
      if(byHandle.has(row[0]))throw new Error('Prodotto duplicato');
      byHandle.set(row[0],i);
      names[row[1]].forEach(function(n) { if(!byName.has(n))byName.set(n,[]);byName.get(n).push(i); });
    });
    function product(i) {
      var p=data.products[i], c=data.cards[p[1]], e=data.editions[p[2]];
      return {index:i,handle:p[0],name:c.n,aliases:[c.n].concat(c.a || []),cardIndex:p[1],editionIndex:p[2],set:e.code,edition:e.name,collectorNumber:p[3],image:/^https:\/\//.test(p[4])?p[4]:data.imagePrefix+p[4],rarity:p[5],colors:c.c,typeLine:c.type,manaValue:c.mv,date:e.date,
        title:c.n+' - '+e.name+' ['+e.code+'-'+p[3]+']',type:'Magic Single',product_type:'Magic Single',_mtgName:c.n,tags:[e.name],url:productUrl(p[0])};
    }
    function lookupName(value) {
      var term=normalize(value),hits=Array.from(new Set(byName.get(term) || [])).map(product);
      var exact=hits.filter(function(p){return normalize(p.name)===term;});
      return exact.length ? exact : hits;
    }
    function search(q) {
      q=q || {}; var term=normalize(q.name), effects=oracleTerms(q.oracle), colors=q.colors || [], scores=new Map();
      if(effects.length && !oracle)throw new Error('Testo carte non ancora caricato');
      var hasExactCanonical=term && names.some(function(n){return n[0]===term;});
      data.cards.forEach(function(c,i) {
        var score=scoreName(names[i],term,!!q.exact);
        if(!score) return;
        if(q.exact && hasExactCanonical && names[i][0]!==term)return;
        if(!matchesColors(c.c,colors,q.colorMode || 'exactly'))return;
        if(effects.length && !effects.every(function(t) { return oracle[i].indexOf(t)!==-1; }))return;
        scores.set(i,score);
      });
      var results=[];
      data.products.forEach(function(row,i) {
        if(!scores.has(row[1]))return;
        if(Array.isArray(q.edition)){if(q.edition.indexOf(row[2])===-1)return;}
        else if(q.edition!==undefined && q.edition!=='' && row[2]!==Number(q.edition))return;
        if(q.year && String(data.editions[row[2]].date || '').slice(0,4)!==String(q.year))return;
        if(q.codes && q.codes.length && q.codes.indexOf(data.editions[row[2]].code)===-1)return;
        if(q.rarity && row[5]!==q.rarity)return;
        results.push(i);
      });
      results.sort(function(a,b) {
        var pa=data.products[a],pb=data.products[b];
        if(q.sort==='newest') { var d=(data.editions[pb[2]].date || '').localeCompare(data.editions[pa[2]].date || ''); if(d)return d; }
        if(q.sort!=='name') { var diff=scores.get(pb[1])-scores.get(pa[1]); if(diff)return diff; }
        return data.cards[pa[1]].n.localeCompare(data.cards[pb[1]].n,'en') || data.editions[pa[2]].name.localeCompare(data.editions[pb[2]].name,'en') || String(pa[3]).localeCompare(String(pb[3]),'en',{numeric:true}) || a-b;
      });
      return {total:results.length,indices:results,items:results.slice(q.offset || 0,(q.offset || 0)+(q.limit || 24)).map(product)};
    }
    function setOracle(payload) {
      if(payload.schema!==1 || payload.version!==data.version || !Array.isArray(payload.oracle) || payload.oracle.length!==data.cards.length) throw new Error('Versione testo carte non coerente');
      oracle=payload.oracle.map(function(o) { return normalize(o.t+' '+(o.k || []).join(' ')); });
    }
    return {data:data,product:product,lookupName:lookupName,search:search,setOracle:setOracle,hasOracle:function(){return !!oracle;},findHandle:function(h){return byHandle.has(h)?product(byHandle.get(h)):null;}};
  }
  function config() { return root && root.EnigmaMtgCatalogConfig || {}; }
  function productUrl(handle) { return (config().root || '/').replace(/\/?$/, '/')+'products/'+encodeURIComponent(handle); }
  var pending=null,index=null,oraclePending=null,details=new Map();
  async function fetchJSON(url,options) {
    options=options || {};
    var controller=new AbortController(),external=options.signal;
    var abort=function(){controller.abort();};
    if(external){if(external.aborted)abort();else external.addEventListener('abort',abort,{once:true});}
    var expired=false,deadline=root.setTimeout(function(){expired=true;abort();},30000);
    try {
      var response=await root.fetch(url,Object.assign({headers:{Accept:'application/json'}},options,{signal:controller.signal}));
      if(!response.ok) { var e=new Error(response.status===404?'Prodotto non più disponibile nel catalogo':'Caricamento non riuscito');e.status=response.status;throw e; }
      return await response.json();
    } catch(error){if(expired)throw new Error('Connessione lenta: riprova a caricare le carte.');throw error;}
    finally {root.clearTimeout(deadline);if(external)external.removeEventListener('abort',abort);}
  }
  function load() {
    if(index)return Promise.resolve(index);
    if(!pending) pending=fetchJSON(config().index).then(function(data){ index=create(data);return index; }).catch(function(e){pending=null;throw e;});
    return pending;
  }
  async function loadOracle() {
    var catalog=await load();
    if(catalog.hasOracle())return catalog;
    if(!oraclePending)oraclePending=fetchJSON(config().oracle).then(function(payload){catalog.setOracle(payload);return catalog;}).catch(function(e){oraclePending=null;throw e;});
    return oraclePending;
  }
  async function hydrate(handle,options) {
    options=options || {};
    var catalog=await load(), entry=catalog.findHandle(handle);
    if(!entry)throw new Error('Prodotto non presente nel catalogo');
    var cached=details.get(handle);
    if(!options.fresh && cached && Date.now()-cached.at<30000)return cached.value;
    // This is a Liquid view, not Shopify's product JSON API. Request its
    // rendered representation, then parse the JSON emitted by the template.
    var data=await fetchJSON(productUrl(handle)+'?view=mtg-single-data',{cache:'no-store',headers:{Accept:'text/html'},signal:options.signal});
    if(data.schema!==1 || data.eligible!==true || data.handle!==handle || data.type!=='Magic Single')throw new Error('Offerta non verificabile');
    var actualTitle=normalize(data.title);
    var identityMatches=entry.aliases.some(function(alias) {
      var expectedName=normalize(alias),remainder=actualTitle.indexOf(expectedName)===0 ? actualTitle.slice(expectedName.length) : null;
      return remainder!==null && (!remainder || /^\s+(?:-|\(v\.\d+\))/.test(remainder));
    });
    if(!identityMatches)throw new Error('Identità della carta cambiata: apri la scheda prodotto');
    data._mtgName=entry.name; data._mtgPrinting=entry; data.featured_image={url:data.image || entry.image};
    details.set(handle,{at:Date.now(),value:data});
    return data;
  }
  return {normalize:normalize,oracleTerms:oracleTerms,matchesColors:matchesColors,scoreName:scoreName,create:create,load:load,loadOracle:loadOracle,hydrate:hydrate,productUrl:productUrl};
});
